import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts with a slight delay for better visibility
    const timer = setTimeout(() => {
      console.log('Navbar animation triggered');
      setIsLoaded(true);
    }, 300);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isLoaded ? 'loaded' : ''}`}>
        <div className="nav-container">
          {/* Logo */}
          <div className="logo">
            <button
              className="logo-button"
              onClick={scrollToTop}
              aria-label="Go to home"
            >
              <img
                src="/logos/gaminggrid-logo.png"
                alt="GamingGrid Agency"
                className="logo-image"
              />
            </button>
          </div>

          {/* Centered Navigation Links */}
          <div className="nav-links">
            <a href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a>
            <a href="#case-studies" onClick={() => setIsMobileMenuOpen(false)}>Work</a>
            <a href="#team" onClick={() => setIsMobileMenuOpen(false)}>Team</a>
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
          </div>

          {/* Get in Touch Button */}
          <div className="nav-actions">
            <button className="cta-button" onClick={scrollToContact}>
              Get in Touch
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Button - Outside nav so it floats independently */}
      <button
        className={`mobile-menu-button ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Mobile Menu - Outside nav to avoid overflow clipping */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-content">
          <a href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a>
          <a href="#case-studies" onClick={() => setIsMobileMenuOpen(false)}>Work</a>
          <a href="#team" onClick={() => setIsMobileMenuOpen(false)}>Team</a>
          <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
          <a href="/creatorfi" className="nav-link">CreatorFi</a>
          <button className="mobile-cta-button" onClick={scrollToContact}>
            Get in Touch
          </button>
        </div>
      </div>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Navbar;